/**
 * Very simple component that renders a list of people
 */

import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'people-list',
  template: `
    <table class="table table-striped">
      <thead>
        <th>Pedido</th>
        <th>Data do Pedido</th>
        <th>Status</th>
        <th class="th-td-acoes">Ações</th>
      </thead>
      <tbody>
        <tr *ngFor="let p of people">
          <td>{{ p.name }}</td>
          <td>{{ p.surname }}</td>
          <td>{{ p.twitter }}</td>          
          <td class="th-td-acoes">
          <button class="btn btn-sm btn-default" (click)="editPerson.emit(p)">
            <span class="material-icons">add</span>
            </button>
            <button class="btn btn-sm btn-default" (click)="editPerson.emit(p)">
              <span class="material-icons">create</span>            
            </button>
            <button class="btn btn-sm btn-default" (click)="editPerson.emit(p)">
              <span class="material-icons">delete</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-default" (click)="addPerson.emit()">Adicionar pedido</button>
  `,
  styles: [
    `
    .th-td-acoes{
      text-align: center;
      vertical-align: middle;
    }
  `
  ]
})
export class PeopleListComponent {
  @Input() people;
  @Output() addPerson = new EventEmitter<any>();
  @Output() editPerson = new EventEmitter<any>();
}
